import { useState, useEffect, useRef } from 'react';
import styles from './BottomNavigation.module.scss';
import { SmallText } from '@components';

type TBottomNavigationProps = {
	onItemClick: (index: number) => void;
	navItems: {
		label: string;
		icon: () => JSX.Element;
	}[]
}

export const BottomNavigation = (props: TBottomNavigationProps) => {
	const {
		navItems,
		onItemClick
	} = props;
	const [isNavVisible, setIsNavVisible] = useState(true);
	const lastScrollYRef = useRef(0);

	useEffect(() => {
		const mainLayout = document.getElementById('mainLayout');
		if (!mainLayout) return;

		const handleScroll = () => {
			const currentScrollY = mainLayout.scrollTop;
			const scrollDelta = currentScrollY - lastScrollYRef.current;

			if (scrollDelta > 0 && scrollDelta >= 50) {
				// Scrolled down ≥ 50px in one go → hide
				setIsNavVisible(false);
			} else if (scrollDelta < 0) {
				// Scrolled up any amount → show
				setIsNavVisible(true);
			}

			lastScrollYRef.current = currentScrollY;
		};

		mainLayout.addEventListener('scroll', handleScroll);
		return () => mainLayout.removeEventListener('scroll', handleScroll);
	}, []);


	return (
		<div data-testid={'@Ofload-BottomNav'} className={`${styles.container} ${!isNavVisible && styles.hide}`}>
			{
				navItems.map((nav, i) => {
					return (
						<div key={i} className={styles.navItem} onClick={() => onItemClick(i)}>
							{
								nav.icon()
							}
							<SmallText text={nav.label} />
						</div>
					)
				})
			}
		</div>
	);
}
